"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJsonapiCatalogImportJob = exports.toCanonicalCatalogImportJob = void 0;
function toCanonicalCatalogImportJob(job) {
    return {
        id: job.id,
        createdBy: job.attributes.createdBy,
        createdAt: new Date(job.attributes.createdAt),
        updatedAt: new Date(job.attributes.updatedAt),
        kind: job.attributes.kind,
        config: job.attributes.config,
        progress: job.attributes.progress,
        result: job.attributes.result,
        state: job.attributes.state,
    };
}
exports.toCanonicalCatalogImportJob = toCanonicalCatalogImportJob;
function toJsonapiCatalogImportJob(job) {
    return {
        id: job.id,
        type: 'Job',
        attributes: {
            createdBy: job.createdBy,
            createdAt: job.createdAt.toISOString(),
            updatedAt: job.updatedAt.toISOString(),
            kind: job.kind,
            config: job.config,
            progress: job.progress,
            result: job.result,
            state: job.state,
        },
    };
}
exports.toJsonapiCatalogImportJob = toJsonapiCatalogImportJob;
//# sourceMappingURL=mappers.js.map